/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plane_Honest_Bird_LiftInputs */

const fr_plane_honest_bird_lift = /** @type {(inputs: Plane_Honest_Bird_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids (kg)`)
};

/**

* @param {Plane_Honest_Bird_LiftInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plane_honest_bird_lift = /** @type {((inputs?: Plane_Honest_Bird_LiftInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plane_Honest_Bird_LiftInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plane_honest_bird_lift(inputs)
});